module.exports = __webpack_public_path__ + "static/media/StepByStep.0bee2c24.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/content/StepByStep.PNG
// module id = 1126
// module chunks = 0